import { ETabs } from '../../types/redux/tabs';
import { ca } from '@cian/analytics';

const TAB_LABELS: Required<Record<ETabs, string>> = {
  [ETabs.Agencies]: 'company',
  [ETabs.Realtors]: 'agent',
};

export const trackOpenCard = (tab: ETabs) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingAgents',
    action: 'to_card',
    label: TAB_LABELS[tab],
  });
};
